import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productAttributeSort',
    pure: true
})
export class BDCPProductAttributeSortPipe implements PipeTransform {

    public transform(
        productAttributes: Array<'ONSITE_3_YEARS' | 'PRINT_AIRBAG_1MIO' | 'PRINT_AIRBAG_750k' | 'PRINT_AIRBAG_400k' | 'PRINT_AIRBAG_350k' | 'PRINT_AIRBAG_200k' | 'PRINT_AIRBAG_150k' | 'PRINT_AIRBAG_100k' | 'PRINT_AIRBAG_15k'>
    ): Array<'ONSITE_3_YEARS' | 'PRINT_AIRBAG_1MIO' | 'PRINT_AIRBAG_750k' | 'PRINT_AIRBAG_400k' | 'PRINT_AIRBAG_350k' | 'PRINT_AIRBAG_200k' | 'PRINT_AIRBAG_150k' | 'PRINT_AIRBAG_100k' | 'PRINT_AIRBAG_15k'> {
        if (!productAttributes) {
            return [];
        }
        const map = {
            'ONSITE_3_YEARS': 0,
            'PRINT_AIRBAG_1MIO': 1,
            'PRINT_AIRBAG_750k': 2,
            'PRINT_AIRBAG_400k': 3,
            'PRINT_AIRBAG_350k': 4,
            'PRINT_AIRBAG_200k': 5,
            'PRINT_AIRBAG_150k': 6,
            'PRINT_AIRBAG_100k': 7,
            'PRINT_AIRBAG_15k': 8
        };
        return productAttributes.sort((a, b) => map[a] > map[b] ? 1 : -1);
    }

}
